const Pane = {
  TOP: 'top',
  BOTTOM: 'bottom',
} as const;
export type PaneE = typeof Pane[keyof typeof Pane];

export default Pane;
